import React from 'react';
import PropTypes from 'prop-types';

const Alert = ({ preview }) => {
  return (
    <div className="bg-notification-wagtail">
      <div className="container mx-auto px-4">
        <div className="py-2 text-center text-sm text-white font-bold">
          {preview.title}{' '}
          <a
            href="/api/exit-preview"
            className="underline font-bold hover:text-basic-300 duration-200 ease-out transition-colors"
          >
            Click here
          </a>{' '}
          to exit preview mode.
        </div>
      </div>
    </div>
  );
};

Alert.propTypes = {
  preview: PropTypes.shape({
    title: PropTypes.string,
  }).isRequired,
};

export default Alert;
